export const SUSTAINED_RATE = 12
export const BURST = 24
export const TICK_MS = 2000
export const CLICK_SOFT_CAP = 160
export const CLICK_SOFT_CAP_BIGINT = 160n
export const CLICK_COOKIE_MULT = 7n
export const CLICK_COOKIE_MULT_NUM = 7
export const DETACH_DELAY_MS = 200
export const COMBO_WINDOW_MS = 3000
export const COMBO_MAX_STACKS = 25
export const COMBO_PCT_PER_STACK = 2
export const CHECKPOINT_MS = 10_000
export const PRESENCE_TIMEOUT_MS = 30_000
export const PRESENCE_THROTTLE_MS = 5_000
export const RESYNC_DEDUPE_MS = 2_000
export const SNEAKY_CHANCE_PER_SEC = 0.025 / 60
export const SNEAKY_MIN_MS = 18_000
export const SNEAKY_MAX_MS = 25_000
export const SNEAKY_RADIUS = 0.15
export const MINI_MAX_CONCURRENT = 3
export const MINI_TTL_MS = 60_000
export const MINI_SPAWN_P_PER_TICK = 0.00475
export const MINI_CLICK_RADIUS = 0.18
export const SPEC_UNLOCK_LEVEL = 2
export const BAKERY_LIVE_TICK_MS = 500
export const API_TIMEOUT_MS = 8000
export const API_GRACE_MS = 2500
export const API_RESYNC_THROTTLE_MS = 8000
export const API_BACKOFF_MAX_MS = 8000
export const AVATAR_TIMEOUT_MS = 1000
export const AVATAR_TIMEOUT_SMALL_MS = 800
export const RUSH_INITIAL_MIN_MS = 90_000
export const RUSH_INITIAL_JITTER_MS = 60_000
export const GOLDEN_INITIAL_MIN_MS = 95_000
export const GOLDEN_INITIAL_JITTER_MS = 70_000
export const RUSH_REPEAT_MIN_MS = 90_000
export const RUSH_REPEAT_JITTER_MS = 90_000
export const GOLDEN_REPEAT_MIN_MS = 95_000
export const GOLDEN_REPEAT_JITTER_MS = 70_000
export const FX_BUMP_THRESHOLDS: readonly number[] = [100, 500, 1000, 2500, 5000]
export const WS_OUTBOX_CLICK_CAP = 200
export const WS_OUTBOX_MAX = 500
export const API_FETCH_TIMEOUT_MS = 12_000
export const API_FETCH_LONG_TIMEOUT_MS = 25_000
export const APP_CHANNEL_AUTH_TIMEOUT_MS = 15_000
export const GUILD_FETCH_TIMEOUT_MS = 12_000
export const NOTICE_OK_MS = 3200
export const NOTICE_ERR_MS = 4200
export const QUEST_SYNC_THROTTLE_MS = 15_000
export const TESTER_WINDOW_MS = 5000
export const TESTER_SEND_INTERVAL_MS = 900
export const TESTER_THROTTLE_MS = 1000
export const CHIME_THROTTLE_MS = 3000
export const PRESENCE_CHECK_TIMEOUT_MS = 10_000
export const PRESENCE_CONCURRENCY = 5
export const GUILDS_OVERALL_TIMEOUT_MS = 8500
export const STREAM_OVERALL_MS = 30_000
export const BOT_MIN_PERMISSIONS = "379968"
export const SESSION_TTL_SEC = 604800
export const PRESENCE_TTL_MS = 60_000
export const EMBED_TTL_MS = 60_000
export const NEGATIVE_TTL_MS = 15_000
export const MANAGE_GUILD_BIT = 32n
export const ADMINISTRATOR_BIT = 8n
export const CLICK_ID_MAX = 128
export const SEEN_CLICK_TTL_MS = 60_000
export const SEEN_CLICK_MAX = 1000
export const SEEN_REQUEST_MAX = 500
export const SEEN_REQUEST_TTL_MS = 300_000
export const CRIT_CAP = 0.25
export const BATCH_FLUSH_MS = 50
export const IDLE_SHORT_MS = 30_000
export const IDLE_LONG_MS = 300_000
export const SNEAKY_FANFARE_MS = 2400
export const MINI_FANFARE_MS = 2400
export const PROJECT_FANFARE_MS = 4200
export const ROOM_SAVE_MIN_MS = 2000
export const ROOM_PRIVATE_CACHE_MS = 5000
export const ROOM_PUBLIC_CACHE_MS = 5000
export const RUSH_FANFARE_BUFFER_MS = 50
export const MINI_TTL_BUFFER_MS = 50
export const PREVIEW_TIMEOUT_MS = 750
export const PREVIEW_META_TIMEOUT_MS = 200
export const API_PREVIEW_TIMEOUT_MS = 800
export const SHELL_TICK_MS = 120
export const CPS_TESTER_INTERVAL_MS = 200
export const CPS_TESTER_WINDOW_MS = 5000
export const CPS_TESTER_THRESH = 0.05
export const TESTER_CPS_MAX = 300
export const TESTER_CPS_MIN = 0
export const OFFLINE_THRESHOLD_MS = 30 * 60 * 1000
export const OFFLINE_MAX_MS = 12 * 3600 * 1000
export const OFFLINE_BASE_RATE = 30
export const OFFLINE_EFFICIENCY_BPS = 2000
export const OFFLINE_SORTER_BPS_PER_LEVEL = 150
export const OFFLINE_SORTER_MAX_LEVELS = 8
export const OFFLINE_MAX_EFFICIENCY_BPS = 3500
export const PASSIVE_DIVISOR = 20000n
export const PASSIVE_MAX_SORTER_LEVEL = 20
export const PASSIVE_BOOST_PCT_PER_LEVEL = 4
export const SETTLE_CAP_SECS = 30 * 24 * 3600
export const SETTLE_CAP_MS = SETTLE_CAP_SECS * 1000
export const CLICK_BOUNDS_MIN = 0.08
export const CLICK_BOUNDS_MAX = 0.92
export const CLICK_JITTER = 0.04
export const CLICK_FALLBACK_SPREAD = 0.09
export const CLICK_FALLBACK_RADIUS_MIN = 0.11
export const CLICK_BIG_THRESHOLD = 6
export const SEEN_SEQ_CAP = 600
export const SEEN_SEQ_KEEP = 400
export const SHELL_CPS_TOP_N = 5
export const LEADERBOARD_MAX = 50
export const COOKIE_CLICK_BOUNDS_MIN = 0.08
export const COOKIE_CLICK_BOUNDS_MAX = 0.92
export const PUBLIC_RATE_LIMIT_CAP = 30
export const PUBLIC_RATE_LIMIT_REFILL = 0.5
export const CORS_MAX_AGE = "86400"
export const BAKERY_STATUS_CHAOS = 16
export const BAKERY_STATUS_BUSY = 8
export const BAKERY_STATUS_BAKING = 2
export const BAKERY_STATUS_QUIET_COOKIES = 10
export const DEFAULT_CLICK_X = 0.5
export const DEFAULT_CLICK_Y = 0.5
